import { normalize } from "diagnostics-lib/string";
import { tokenize } from "@ui/lib/hooks/useFilteredDatas";
import type { Dashboard } from "../hook/api/dashboard";

export function filterPublishedDashboards(
  dashboards: Dashboard[],
  searchQuery: string,
): Dashboard[] {
  const tokens = tokenize(normalize(searchQuery));

  if (tokens.length === 0) {
    return dashboards;
  }

  return dashboards.filter(dashboard =>
    tokens.some(token => {
      const normalizedTitle = normalize(dashboard.title);
      const normalizedDescription = normalize(dashboard.description || "");

      return normalizedTitle.includes(token) || normalizedDescription.includes(token);
    }),
  );
}
